import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/icons-material/esm/AssignmentIndOutlined.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/icons-material/esm/LocalShippingOutlined.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/home/carousel/HomeCaru.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/home/semiAbout/semiabout.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/home/semiItems/ProductCarousel.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/language/TranslationsProvider.js");
